class ReceiptheroController extends AbstractIntegrationController
	@register()
	@inject 'configurationOptions', '$window'

	integrationId: 'receipthero'

	initialize: ->
		@showFormActionButtons = false

	goToRegistrationPage: ->
			@$window.open(@configurationOptions.register_page_url, '_blank')
